import { render } from "./ServiceIcons.vue?vue&type=template&id=520351fc&scoped=true"
import script from "./ServiceIcons.vue?vue&type=script&lang=js"
export * from "./ServiceIcons.vue?vue&type=script&lang=js"

import "./ServiceIcons.vue?vue&type=style&index=0&id=520351fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520351fc"]])

export default __exports__